export default {
    init() {
        function close_open_modal() {
            $.magnificPopup.close();
        }

        function alert_modal(params) {
            var defaults = {
                title: 'Alert',
                message: '',
                button_text: 'OK',
                modal_class: '',
            };

            var merged = Object.assign(defaults, params);

            var modal = $('<div />').addClass('modal-alert-popup');
            if (merged.modal_class) {
                modal.addClass(merged.modal_class);
            }
            var modal_title = $('<div />').addClass('modal-title').html(merged.title);
            var message = $('<p />').html(merged.message);
            var buttons = $('<div />').addClass('buttons');
            var ok_button = $('<button />').addClass('button-ok').html(merged.button_text).click(function(e) {
                e.preventDefault();
                close_open_modal();
            });
            buttons.append(ok_button);
            modal.append(modal_title).append(message).append(buttons);

            $.magnificPopup.open({
                closeOnContentClick: false,
                items: {
                    src: modal,
                },
                modal: false,
                type: 'inline',
            });
        }


        $('.popup-image').magnificPopup({
            'type': 'image',
        });

        //if (window.location.hash.indexOf('#gf_1') < 0) {
        //  var notice_params = {
        //    title: 'Unexpected Delay',
        //    message: '<p>The <strong>Division of Corporations</strong> (the department that appoints ALL notaries for the State of Florida) will be closed until Monday, July 27, 2020 - at which time applications will be processed in the order in which they were received.  For this reason, we are continuing to forward notary applications to the state and encourage you to <strong>complete</strong> your application.</p><p>We <strong>apologize for this</strong> unforeseen delay in the processing of your notary application, but you can be confident that we will expedite the assembly of your notary package upon the State\'s approval of your commission.</p><p>Please refer to the State\'s website for more updates: <a href="https://dos.myflorida.com/sunbiz/" target="_blank">https://dos.myflorida.com/sunbiz/</a></p>',
        //    button_text: 'OK',
        //    modal_class: 'notice',
        //  };
        //  alert_modal(notice_params);
        //}

        $('#choice_1_29_1').click(function() {
            if ($(this).is(':checked')) {
                var params = {
                    title: 'Notice',
                    message: 'A recorded Declaration of Domicile obtained from your local courthouse is required.',
                    button_text: 'OK',
                    modal_class: 'citizen-alert',
                };
                alert_modal(params);
            }
        });

        $('#choice_1_187_0').click(function() {
            if ($(this).is(':checked')) {
                var params = {
                    title: 'Notice',
                    message: 'A written request for the fee reduction must be submitted, and proof of exemption provided.',
                    button_text: 'OK',
                    modal_class: 'citizen-alert',
                };
                alert_modal(params);
            }
        });

        $('#choice_1_37_0').click(function() {
            if ($(this).is(':checked')) {
                var params = {
                    title: 'Notice',
                    message: 'You must provide a written statement about the nature of the action and any supporting documentation. For example, a copy of the Final Order from the regulating agency.',
                    button_text: 'OK',
                    modal_class: 'citizen-alert',
                };
                alert_modal(params);
            }
        });

        $('#choice_1_38_0').click(function() {
            if ($(this).is(':checked')) {
                var params = {
                    title: 'Notice',
                    message: 'You must provide a written statement about the nature of the action and any supporting documentation. For example, a copy of the Final Order from the regulating agency.',
                    button_text: 'OK',
                    modal_class: 'citizen-alert',
                };
                alert_modal(params);
            }
        });

        $('#choice_1_39_0').click(function() {
            if ($(this).is(':checked')) {
                var params = {
                    title: 'Notice',
                    message: 'You must provide a written statement of the nature of the offense(s), a copy of the court judgment and sentencing order. If applicable, you must also provide a certificate of Restoration of Civil Rights.',
                    button_text: 'OK',
                    modal_class: 'citizen-alert',
                };
                alert_modal(params);
            }
        });

        $('#choice_1_63_1').click(function() {
            if ($(this).is(':checked')) {
                var params = {
                    title: 'Important Notice',
                    message: 'E&amp;O is not required but is important protection for any notary public. Please understand that if you do not have this insurance, you are personally liable should a lawsuit be brought against you in connection with your duties as a notary.',
                    button_text: 'OK',
                    modal_class: 'e-o-note',
                };
                alert_modal(params);
            }
        });

        $('#input_1_79').change(function() {
            if ($(this).val().split('|')[0] === 'Express Shipping') {
                var params = {
                    title: 'Notice',
                    message: 'Express shipping applies only to your notary package - <strong>not</strong> your processing.',
                    button_text: 'OK',
                    modal_class: 'citizen-alert',
                };
                alert_modal(params);
            }
        });

        var sec_codes = $('.ginput_card_security_code');
        if (sec_codes.length) {
            sec_codes.each(function() {
                var input = $(this);
                var container = input.parent();
                var img_url = '/app/themes/flnotary/dist/images/cvv-graphic.png';
                var hover_span = $('<span />').addClass('cvv-graphic').append($('<img />').attr('src', img_url).attr('alt', ''));

                container.closest('.ginput_cardextras').css('overflow', 'visible');
                container.addClass('hover-graphic-enabled');
                hover_span.insertAfter(input);
            });
        }

        var zips = $('.address_zip > input[type=text]');
        if (zips.length) {
            console.log(zips);
            zips.inputmask('99999');
        }

        $('.mfp-video').magnificPopup({
            type: 'iframe',
            iframe: {
                markup: '<div class="mfp-iframe-scaler">' +
                        '<div class="mfp-close"></div>' +
                        '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                        '</div>',
                patterns: {
                    youtube: {
                        index: 'youtube.com/',
                        id: 'v=',
                        src: '//www.youtube.com/embed/%id%?autoplay=1&amp;rel=0&amp;showinfo=0', // URL that will be set as a source for iframe.
                    },
                    vimeo: {
                        index: 'vimeo.com/',
                        id: '/',
                        src: '//player.vimeo.com/video/%id%?autoplay=1',
                    },
                },
                srcAction: 'iframe_src',
            },
        });
        // JavaScript to be fired on all pages

        $(window).on('load', function() {
            $('.off-canvas').mCustomScrollbar();
        });

        /* g l obal balanceText*/
        /*var balance_elements = $(
            '.balance-text, h1, h1 span, h2, h2 span, h3, h3 span, h4, h4 span, h5, h5 span, h6, h6 span, .title, .block-title');
        if (balance_elements.length) {
            balance_elements.each(function() {
                if (!$(this).find('span').length) {
                    balanceText($(this), {watch: true});
                }
            });

            balanceText($('.banner .text > *'), {watch: true});
        }*/
        //balanceText($('.balance-text, h1, h1 span, h2, h2 span, h3, h3 span, h4,
        // h4 span, h5, h5 span, h6, h6 span, .title, .block-title'), {watch:
        // true});

        var check_image_size = function(container) {
            //var image_container = container.parent();
            var img = container.find('img');
            if (container.hasClass('horizontal')) {
                if (container.outerHeight() > img.outerHeight()) {
                    container.removeClass('horizontal').addClass('vertical');
                }
            }
            else if (container.hasClass('vertical')) {
                if (container.outerWidth() > img.outerWidth()) {
                    container.removeClass('vertical').addClass('horizontal');
                }
            }
        };

        var half_image_content = $('.page-section.side-image');
        if (half_image_content.length) {
            half_image_content.each(function() {
                var container = $(this);
                var img_container = container.find('.image');
                check_image_size(img_container);
                setTimeout(function() {
                    check_image_size(img_container);
                }, 500);
                setTimeout(function() {
                    check_image_size(img_container);
                }, 1000);
                setTimeout(function() {
                    check_image_size(img_container);
                }, 2000);
                $(window).resize(function() {
                    check_image_size(img_container);
                });
            });
        }
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};
